import {fetch_post} from "../helpers/Fetch";
import {MetaFieldDescription, MetaFieldGroup} from "../components/Dealer/News/MetaFields";

export type DealerNewsEntity = {
    post_id?: number,
    date: string,
    title: string,
    content: string,
    picture: number,
    picture_url: string,
    meta_fields?: string,
}

export type DealerNewsCollection = DealerNewsEntity[];

export type DealerNewsEntityKeys = keyof DealerNewsEntity;

export class DealerNewsService {

    private endpoint = '/wp-json/vanderhall/dealer/news/v1';

    private metaFields: string[] = [];

    constructor(private dealer_id: number, private category: string, private lang: string, private metaFieldGroups: MetaFieldGroup[]) {
        metaFieldGroups.map(metaFieldGroup => {
            metaFieldGroup.fields.map(metaField => {
                this.metaFields.push(metaField.name);
            })
        })
    }

    public async getList() {
        return new Promise<DealerNewsCollection>((resolve, reject) => {
            fetch_post(this.endpoint + '/list', {
                dealer_id: this.dealer_id,
                category: this.category,
                lang: this.lang,
                meta_fields: JSON.stringify(this.metaFields),
            }).then(response => response.json()).then((result) => {
                resolve(result.entries)
            }).catch(() => reject())
        });
    }

    public async update(news: DealerNewsEntity) {
        return new Promise((resolve, reject) => {
            fetch_post(this.endpoint + '/update', news).then(response => response.json()).then((result) => {
                resolve()
            }).catch(() => reject())
        });
    }

    public async delete(news: DealerNewsEntity) {
        return new Promise((resolve, reject) => {
            fetch_post(this.endpoint + '/delete', news).then(response => response.json()).then((result) => {
                resolve()
            }).catch(() => reject())
        });
    }

    public async create() {
        return new Promise<number>((resolve, reject) => {
            fetch_post(this.endpoint + '/create', {
                category: this.category,
                dealer_id: this.dealer_id,
                lang: this.lang,
            }).then(response => response.json()).then((result) => {
                resolve(result.post_id)
            }).catch(() => reject())
        });
    }

}